import { DEFAULT_REGROUPMENT } from 'catchment/constants/CatchmentConstant'
import { isNil } from 'lodash'
import moment from 'moment'
import useApplicationSetting, { intParser } from 'utils/customHook/useApplicationSetting'

const useStartPeriod = (parser = setting => setting) => {
    const regroupment = useApplicationSetting('CATCHMENT_REGROUPING', intParser) ?? DEFAULT_REGROUPMENT
    const startPeriod = useApplicationSetting('CATCHMENT_START_PERIOD', intParser)
    const endPeriod = useApplicationSetting('CATCHMENT_END_PERIOD', intParser)

    if (isNil(startPeriod) && isNil(endPeriod)) return parser(moment().year() - regroupment + 1)

    return parser(startPeriod ?? endPeriod - regroupment + 1)
}

export default useStartPeriod